import moment from 'moment';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import { valueFormat } from '@/pages/intelligence/utils/commonUtils';
import {
  IEntityType,
  IBigRiserKeyMap,
  ITableSpecialColProp,
  ILineChartInterfaceProp,
} from '../../typings';
import { IRegion } from '@/pages/home/types/common';
import { getPlatformList } from '../../utils';

export const ENTITY_TYPE_MAP = {
  total: 'Mobile',
  mobile: 'Mobile',
  pc: 'PC',
  console: 'Console',
};

export const PAGE_LOG_CONFIG_KEYS: any = {
  ['mobile']: 'genreProfileDetailInsightsMobileGameMarket',
  ['pc']: 'genreProfileDetailInsightsPCGameMarket',
  ['console']: 'genreProfileDetailInsightsConsoleGameMarket',
};

export const SUB_MODULE_CONFIG = {
  common: {
    dynamicTableKeyMap: {
      id: 'appId',
      gametitle: 'name',
      metricList: 'metrics_list',
      cover: 'cover',
      publisher: 'publisher',
      countryIcon: 'country_img',
      textBubble: 'rankType',
      platform: 'platform',
      imgType: 'imgType',
      // 右键跳转用
      linkUrl: 'linkUrl',
      metricTitle: 'title',
      metricSource: 'source',
      metricName: 'metric',
      metricRatio: 'growth_ratio',
      metricValue: 'value',
    } as IBigRiserKeyMap,
    getTotalByDate: ({
      dateStr,
      metric,
      _list,
    }: {
      dateStr: string;
      metric: string;
      _list: any;
    }) => {
      if (!metric) metric = 'rev';
      const find = _list.find((item: any) => item.date === dateStr);
      if (find) return find[metric];
      return 0;
    },
    getPercent: (target: number) => {
      return Math.round(target * 100);
    },
    getFormattedDate: (dateStr: string) => {
      return moment(dateStr).format('MMM DD, YYYY');
    },
    // 表格上的文本气泡，可查看Big Riser
    getTextBubbleTips: (str: string) => {
      if (!str) return '';
      return str.indexOf('Dominate') != -1
        ? 'dbi_genre_profile_big_riser_bubble_dominate'
        : str.indexOf('New') != -1
        ? 'dbi_genre_profile_big_riser_bubble_new'
        : 'dbi_genre_profile_big_riser_bubble_other';
    },
    getTextBubbleKeyword: (str: string) => {
      if (!str) return '';
      return str.indexOf('Dominate') != -1
        ? 'dbi_genre_profile_big_riser_bubble_keyword_dominate'
        : str.indexOf('New') != -1
        ? 'dbi_genre_profile_big_riser_bubble_keyword_new'
        : 'dbi_genre_profile_big_riser_bubble_keyword_other';
    },
    getTextBubbleColor: (str: string): { color: string; bgColor: string } => {
      if (!str)
        return {
          color: '',
          bgColor: '',
        };
      let color = '#0076ff';
      let bgColor = '#0076ff1a';
      if (str.includes('Dominate')) {
        color = '#ff9d00';
        bgColor = '#ff9d001a';
      } else if (str.includes('New')) {
        color = '#0abf5b';
        bgColor = '#0abf5b1a';
      }
      return {
        color,
        bgColor,
      };
    },
    dynamicTableFormatter: (tableData: any, targetMetricList: any, entityType: IEntityType) => {
      return tableData?.map(
        (games: { metrics: any[]; id: string; location_country: string; rank_type: string }) => {
          const fetchMetrics = games?.metrics || [];
          const { id, location_country, platform } = games || {};
          return {
            ...games,
            appId: id,
            platform: entityType === 'console' ? getPlatformList(platform) : null,
            imgType: entityType,
            country_img: getCountryFlag(location_country),
            linkUrl: getDetailGamePathCommon({
              entityType,
              gameId: id,
              tab: 'overview',
            }),
            metrics_list: targetMetricList?.map((item) => {
              const { title, source: mapSource, metric: mapMetric } = item;
              // const find = fetchMetrics.find((metric) => metric.metric === mapMetric && metric.source === mapSource);
              const find = fetchMetrics?.find((metric) => metric.metric === mapMetric);
              if (find) {
                const { dod, value, rank_type } = find || {};
                return {
                  title,
                  growth_ratio: dod,
                  metric: mapMetric,
                  source: mapSource,
                  value,
                  rankType: rank_type,
                };
              }
              return {
                title,
                growth_ratio: null,
                metric: mapMetric,
                source: mapSource,
                value: null,
                rankType: null,
              };
            }),
          };
        },
      );
    },
  },
  newBlockbusterGame: {
    getFormatterTableData: (
      tableData: any,
      regionOptions: IRegion[],
      entityType: IEntityType = 'mobile',
    ) => {
      if (!tableData) tableData = [];
      const metricMap: any = {
        appannie: 'Revenue',
        mscience: 'Digital Revenue',
        newzoo: 'MAU',
        steamcharts: 'Steam PCU',
        npd: 'Physical Revenue',
      };
      return tableData?.map((item: any) => {
        const {
          entity_image,
          id,
          cover,
          name,
          publisher,
          location_country,
          source,
          value,
          desc,
          platform,
        } = item || {};
        const [dataSource] = source.split(' ') || ['appannie'];
        return {
          img: entity_image,
          appId: id,
          list: {
            appId: id,
            img: cover,
            gametitle: name,
            text: publisher,
            icon: entityType === 'console' ? getPlatformList(platform) : null,
            countryIcon: getCountryFlag(location_country),
            imgType: entityType,
          },
          iconList: entityType === 'console' ? getPlatformList(platform) : null,
          icon: getDataSourceIcon(dataSource),
          desc: `${metricMap[dataSource]} ${valueFormat(value)}`,
          title: `The description of the ${name}`,
          text: desc,
          linkUrl: getDetailGamePathCommon({
            entityType,
            gameId: id,
            tab: 'overview',
          }),
        };
      });
    },
  },
  marketCRTenByRevenue: {
    getFormatterTableData: (tableData: any, entityType: IEntityType) => {
      if (!tableData) tableData = [];
      return tableData?.map((item: any) => {
        const { rank, cover, name, publisher, value, location_country, platform, id, dod } =
          item || {};
        return {
          appId: id,
          img: cover,
          gametitle: name,
          rank,
          text: publisher.split('|'),
          icon: entityType === 'console' ? getPlatformList(platform) : null,
          dau: valueFormat(value),
          percent: that.common.getPercent(dod),
          // 手游没有国家
          countryIcon: entityType === 'mobile' ? null : getCountryFlag(location_country),
          imgType: entityType,
          hasTextBubble: entityType === 'mobile',
          linkUrl: getDetailGamePathCommon({
            entityType,
            gameId: id,
            tab: 'overview',
          }),
        };
      });
    },
    datasource: {
      mobile: {
        title: 'dbi_revenue_$',
        value: 'appannie',
        metric: 'revenue',
        metricExplanation: ['dbi_info_appannie_revenue_tip'],
      },
      pc: {
        title: 'dbi_metric_digitalRevenue',
        value: 'mscience',
        metric: 'digital_revenue',
        metricExplanation: ['dbi_info_physical_revenue_tip'],
      },
      console: {
        title: 'dbi_metric_digitalRevenue',
        value: 'mscience',
        metric: 'digital_revenue',
        metricExplanation: ['dbi_info_physical_revenue_tip'],
      },
      total: {
        title: 'dbi_revenue_$',
        value: 'appannie',
        metric: 'revenue',
        metricExplanation: ['dbi_info_appannie_revenue_tip'],
      },
    } as any,
    getXAxisAndSeriesData: (_originData: ILineChartInterfaceProp[], entityType: IEntityType) => {
      if (!_originData) _originData = [];
      const xAxis: any[] = [];
      // 日期的数据会被转换，导致无法选中，因此需要把原始日期带上
      const xAxisOri: any[] = [];
      const lineSeriesData: any[] = [];
      const barSeriesData: any[] = [];

      const dateFormatter = (time: any, needDay = true) => {
        const targetTime = time === '1970-01-01' ? moment() : moment(time);
        return needDay ? targetTime.format('YYYY-MM-DD') : targetTime.format('YYYY-MM');
        // return needDay ? targetTime.format('MMM DD, YYYY') : targetTime.format('MMM , YYYY')
      };

      // const fixLineData = (array: any[], index: number) => {
      //   let dif = index - array.length;
      //   for (let i = 0; i < dif; i++) {
      //     array.push('-');
      //   }
      //   return array;
      // };

      // if (flag && trendRes?.data?.end_date) {
      //   setTrendTime(trendRes.data.end_date);
      //   if (param.entity_type == 'mobile') {
      //     changeDefaultTime(trendRes.data.end_date)
      //   }
      // }

      _originData?.forEach((item: ILineChartInterfaceProp, index: number) => {
        const { cr10_rev: cr10Rev, dod, date } = item;
        xAxis.push(dateFormatter(date, entityType == 'mobile' || entityType == 'total'));
        xAxisOri.push(date);
        // barSeriesData = fixLineData(barSeriesData, index)
        barSeriesData.push(!cr10Rev ? '-' : cr10Rev.toFixed(2));
        // lineSeriesData = fixLineData(lineSeriesData, index)
        lineSeriesData.push(dod);
      });

      return {
        xAxis,
        xAxisOri,
        series: {
          line: lineSeriesData,
          bar: barSeriesData,
        },
      };
    },
    action: {
      type: 'text',
      text: 'More',
      position: 'top-right',
      linkTo: '/intelligence/genreProfile/mobileGames/detail/stats',
    },
  },
  BigRiserGames: {
    isTitleCanBeClick: false,
    tableMetricList: {
      mobile: [
        {
          title: 'dbi_revenue_$',
          source: 'appannie',
          metric: 'revenue',
          metricExplanation: ['dbi_info_appannie_revenue_tip'],
          align: 'center',
          childWidth: 160,
          childAlign: 'right',
        },
        {
          title: 'dbi_downloads',
          source: 'appannie',
          metric: 'download',
          metricExplanation: ['dbi_info_appannie_downloads_tip'],
          align: 'center',
          childWidth: 160,
          childAlign: 'right',
        },
        {
          title: 'dbi_revenue_$',
          source: 'sensortower',
          metric: 'revenue',
          metricExplanation: ['dbi_info_sensortower_revenue_tip'],
          align: 'center',
          childWidth: 160,
          childAlign: 'right',
        },
        {
          title: 'dbi_downloads',
          source: 'sensortower',
          metric: 'download',
          metricExplanation: ['dbi_info_sensortower_downloads_tips'],
          align: 'center',
          childWidth: 160,
          childAlign: 'right',
        },
      ],
      newmobile: (dataSource: any) => {
        return [
          {
            title: 'dbi_revenue_$',
            source: dataSource,
            metric: 'revenue',
            metricExplanation: [`dbi_info_${dataSource}_revenue_tip`],
            align: 'center',
            childWidth: 160,
            childAlign: 'right',
          },
          {
            title: 'dbi_downloads',
            source: dataSource,
            metric: 'download',
            metricExplanation: [`dbi_info_${dataSource}_downloads_tip`],
            align: 'center',
            childWidth: 160,
            childAlign: 'right',
          },
        ];
      },
      pc: [
        {
          title: 'dbi_genre_profile_monthly_digital_revenue',
          source: 'mscience',
          metric: 'revenue',
          metricExplanation: [
            'dbi_info_digital_revenue_tip',
            'dbi_info_monthly_digital_revenue_genre_profile__tip',
          ],
          align: 'center',
          childWidth: 260,
          childAlign: 'right',
        },
        {
          title: 'dbi_genre_profile_newzoo_mau',
          source: 'newzoo',
          metric: 'mau',
          metricExplanation: ['dbi_info_newzoo_mau_tip', 'dbi_info_newzoo_mau_genre_profile_tip'],
          align: 'center',
          childWidth: 220,
          childAlign: 'right',
        },
        {
          title: 'dbi_genre_profile_daily_steam_pcu',
          source: 'steamcharts',
          metric: 'pcu',
          metricExplanation: ['dbi_info_steam_pcu_tip', 'dbi_info_steam_pcu_genre_profile_tip'],
          align: 'center',
          childWidth: 260,
          childAlign: 'right',
        },
      ],
      console: [
        {
          title: 'dbi_genre_profile_monthly_digital_revenue',
          source: 'mscience',
          metric: 'revenue',
          metricExplanation: [
            'dbi_info_digital_revenue_tip',
            'dbi_info_monthly_digital_revenue_genre_profile__tip',
          ],
          align: 'center',
          childWidth: 260,
          childAlign: 'right',
        },
        {
          title: 'dbi_genre_profile_monthly_physical_revenue',
          source: 'npd',
          metric: 'revenue',
          metricExplanation: [
            'dbi_info_physical_revenue_tip',
            'dbi_info_monthly_physical_revenue_genre_profile__tip',
          ],
          align: 'center',
          childWidth: 270,
          childAlign: 'right',
        },
        {
          title: 'dbi_genre_profile_newzoo_mau',
          source: 'newzoo',
          metric: 'mau',
          metricExplanation: ['dbi_info_newzoo_mau_tip', 'dbi_info_newzoo_mau_genre_profile_tip'],
          align: 'center',
          childWidth: 170,
          childAlign: 'right',
        },
      ],
      total: [],
    },
    // 预处理方法，用于格式化，方便后续后端代码重构
    preFormatter: (tableData: any, targetMetricList: any, marketType: IEntityType) =>
      that.common.dynamicTableFormatter(tableData, targetMetricList, marketType),
    firstCol: [
      {
        title: 'dbi_games',
        type: 'gameInfo',
        key: 'gametitle',
        hasSort: false,
        defaultSort: false,
        hasCheckbox: false,
        hasRank: false,
        canBeClick: true,
        width: 360,
      },
    ],
  },
  NewReleaseGames: {
    isTitleCanBeClick: true,
    tableMetricList: {
      mobile: [
        {
          title: 'dbi_top_pheat',
          source: 'databrain',
          metric: 'pHeat',
          align: 'center',
          metricExplanation: ['dbi_info_pheat_the_predicted_value'],
          childWidth: 140,
          childAlign: 'right',
          // 环比是否隐藏，默认为展示
          ratioHide: true,
        },
        {
          title: 'dbi_revenue_$',
          source: 'appannie',
          metric: 'revenue',
          align: 'center',
          metricExplanation: ['dbi_info_appannie_revenue_tip'],
          childWidth: 160,
          childAlign: 'right',
        },
        {
          title: 'dbi_downloads',
          source: 'appannie',
          metric: 'download',
          metricExplanation: ['dbi_info_appannie_downloads_tip'],
          align: 'center',
          childWidth: 160,
          childAlign: 'right',
        },
        {
          title: 'Revenue($)',
          source: 'sensortower',
          metric: 'revenue',
          metricExplanation: ['dbi_info_sensortower_revenue_tip'],
          align: 'center',
          childWidth: 160,
          childAlign: 'right',
        },
        {
          title: 'Downloads',
          source: 'sensortower',
          metric: 'download',
          metricExplanation: ['dbi_info_sensortower_downloads_tips'],
          align: 'center',
          childWidth: 160,
          childAlign: 'right',
        },
      ],
      pc: [
        {
          title: 'dbi_top_pheat',
          source: 'databrain',
          metric: 'pHeat',
          metricExplanation: ['dbi_info_pheat_the_predicted_value'],
          ratioHide: true,
          align: 'center',
          childWidth: 140,
          childAlign: 'right',
        },
        {
          title: 'dbi_genre_profile_steam_pcu',
          source: 'steamcharts',
          metric: 'pcu',
          metricExplanation: ['dbi_info_steam_pcu_tip'],
          align: 'center',
          childWidth: 160,
          childAlign: 'right',
        },
        {
          title: 'dbi_genre_profile_steam_trending',
          source: 'steamcharts',
          metric: 'steam new and trending_rank',
          metricExplanation: ['dbi_steam_newtrending_info'],
          valueType: 'hashMark',
          align: 'center',
          childWidth: 220,
          childAlign: 'right',
        },
      ],
      console: [
        {
          title: 'dbi_top_pheat',
          source: 'databrain',
          metric: 'pHeat',
          metricExplanation: ['dbi_info_pheat_the_predicted_value'],
          align: 'center',
          childWidth: 140,
          childAlign: 'right',
        },
        {
          title: 'dbi_company_new_games',
          source: 'playstation',
          metric: 'playstation new games_rank',
          metricExplanation: ['dbi_nintendo_newgames_info'],
          valueType: 'hashMark',
          align: 'center',
          childWidth: 160,
          childAlign: 'right',
        },
        {
          title: 'dbi_new_release',
          source: 'xbox',
          metric: 'xbox new release_rank',
          metricExplanation: ['dbi_xbox_newrelease_info'],
          valueType: 'hashMark',
          align: 'center',
          childWidth: 160,
          childAlign: 'right',
        },
      ],
      total: [],
    },
    preFormatter: (tableData: any, targetMetricList: any, marketType: IEntityType) =>
      that.common.dynamicTableFormatter(tableData, targetMetricList, marketType),
    ratioHideCol: ['pHeat'],
    infoCol: [
      {
        key: 'pHeat',
        text: 'dbi_info_pheat_the_parameter_factors',
      },
    ],
    interfaceMap: {
      mobile: 'new_release_mobile_games',
      pc: 'new_release_pc_games',
      console: 'new_release_console_games',
      total: 'new_release_mobile_games',
    },
    // 特殊列
    specialCol: [
      {
        type: 'text',
        title: 'dbi_label_release_date',
        key: 'release_date',
        // 隐藏的条件,多个条件以;分割
        hideCond: 'mobile',
      },
    ] as ITableSpecialColProp[],
    titleAdditionalIcon: 'arrow-right',
    firstCol: [
      {
        title: 'dbi_games',
        type: 'gameInfo',
        key: 'gametitle',
        hasSort: false,
        defaultSort: false,
        hasCheckbox: false,
        hasRank: false,
        canBeClick: true,
        width: 360,
      },
    ],
  },
  UpcomingGames: {
    isTitleCanBeClick: true,
    tableMetricList: {
      mobile: [
        {
          title: 'dbi_top_pheat',
          source: 'databrain',
          metric: 'pHeat',
          metricExplanation: ['dbi_info_pheat_the_predicted_value'],
          align: 'center',
          childWidth: 140,
          childAlign: 'right',
        },
      ],
      pc: [
        {
          title: 'dbi_top_pheat',
          source: 'databrain',
          metric: 'pHeat',
          metricExplanation: ['dbi_info_pheat_the_predicted_value'],
          align: 'center',
          childWidth: 140,
          childAlign: 'right',
        },
      ],
      console: [
        {
          title: 'dbi_top_pheat',
          source: 'databrain',
          metric: 'pHeat',
          metricExplanation: ['dbi_info_pheat_the_predicted_value'],
          align: 'center',
          childWidth: 140,
          childAlign: 'right',
        },
      ],
      total: [],
    },
    preFormatter: (tableData: any, targetMetricList: any, marketType: IEntityType) =>
      that.common.dynamicTableFormatter(tableData, targetMetricList, marketType),
    ratioHideCol: ['pHeat'],
    infoCol: [
      {
        key: 'pHeat',
        text: 'dbi_info_pheat_the_parameter_factors',
      },
    ],
    // 特殊列
    specialCol: [
      {
        type: 'text',
        title: 'dbi_label_release_date',
        key: 'release_date',
      },
    ] as ITableSpecialColProp[],
    titleAdditionalIcon: 'arrow-right',
    firstCol: [
      {
        title: 'dbi_games',
        type: 'gameInfo',
        key: 'gametitle',
        hasSort: false,
        defaultSort: false,
        hasCheckbox: false,
        hasRank: false,
        canBeClick: true,
        width: 360,
      },
    ],
  },
};

const that = SUB_MODULE_CONFIG;
